module.exports = __webpack_public_path__ + "static/media/tennis.914d15a7.svg";